import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { finalize, Observable, tap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { DataService } from '../services/data.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  private excludedRoutes = [
    '/auth/login',
    '/auth/verify2fa',
    '/auth/generate2fa',
    'auth/generateQR',
    '/users/registerDashboard',
    '/users/registerVisitor',
    '/users/verifyEmail',
    '/users/verifyTemporaryPass',
  ];
  apiBase = environment.apiUrl;

  constructor(private dataService: DataService, private router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isExcluded = this.excludedRoutes.some((route) =>
      req.url.includes(route)
    );

    if (isExcluded) {
      return next.handle(req);
    }

    const isExternal = !req.url.startsWith(this.apiBase);

    if (isExternal) {
      return next.handle(req);
    }

    const authToken: string =
      localStorage.getItem('token')?.toString().replace(/['"]+/g, '') || '';
    const token = localStorage.getItem('token');
    if (this.dataService.isTokenExpired(token)) {
      localStorage.clear();
      this.router.navigateByUrl('/pages/login');
      return throwError(() => new Error('Token expirado'));
    }

    let authReq = req;
    let ok: string;

    if (authToken) {
      authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${authToken}`),
      });
    }

    // return next.handle(authReq);

    return next.handle(authReq).pipe(
      tap({
        next: (event: any) => {
          ok = event instanceof HttpResponse ? 'succeeded' : '';
        },
        error: (error: any) => {
          ok = 'failed';
          // console.log(error.status);
          // window.location.href = "/logout";
        },
      }),
      finalize(() => {
        // const msg = `${req.method} "${req.urlWithParams}" ${ok}`;
        // console.log(msg)
      })
    );
  }
}
